/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticlePaywall/theme';

export const ArticlePaywallTheme = theme;
